import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from "@angular/core";

@Component({
    selector: "sps-search-results-bar",
    templateUrl: "./sps-search-results-bar.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SpsSearchResultsBarComponent {
    static readonly displayName = "sps-search-results-bar";
    static readonly props = {
        resultsCount: "number",
        totalResults: "number",
        clear: { event: true, type: "void" },
    };

    @Input() resultsCount: number;
    @Input() totalResults: number;

    @Output() clear = new EventEmitter<void>();

    @HostBinding("class.sps-search-results-bar") readonly _spsSearchResultsBarClass = true;
}
